import { EventEmitter } from "eventemitter3";
import { ConfigType } from "../../pages/questionnaire/pages/detail/fragments/section/contextProvider/provider/types";
import { SnackbarFormat } from "../../utils/types/generals";
import { ModalState } from "../../pages/questionnaire/pages/detail/typing/types";
import { QueryClient } from "@tanstack/react-query";

export const eventEmitter = new EventEmitter();

/**
 * Parameters associated with each event.
 */

export enum Events {
    orderQuestion = 'orderQuestion',
    editQuestion = 'editQuestion',
    removeQuestion = 'removeQuestion',
    openQuestion = 'openQuestion',
    openConfig = 'openConfig',
    closeDrawer = 'closeDrawer',
    comment = 'comment',
    snackbar = 'snackbar',
    modal = 'mnodal',
    modal_close = 'modal_close',
    modal_extra = 'modal_extra',
}
export type EventParams = {
    [Events.orderQuestion]: any[],
    [Events.editQuestion]: {
        id: string;
    },
    [Events.removeQuestion]: {
        id: string;
    },
    [Events.openQuestion]: {
        id: Array<string> | null; name: ConfigType
    },
    [Events.snackbar]: SnackbarFormat,
    [Events.openConfig]: {
        id: Array<string> | null
    },
    [Events.closeDrawer]: undefined,
    [Events.comment]: undefined,
    [Events.modal]: ModalState,
    [Events.modal_extra]: ModalExtra,
};

type ModalExtra = Partial<ModalState>
/**
 * Contains the names of the events that can be emitted in the application.
 */
export const queryClient = new QueryClient()
export enum EventQuery {
    'unit_schedule' = 'unit_schedule',
    'user_schedule' = 'user_schedule',
    'store_performance_critical_sections' = 'store_performance_critical_sections',
    'store_performance_process_result' = 'store_performance_process_result',
}
/**
 * Types of events that can be emitted in the application.
 */
export type EventsKeys = (typeof Events)[keyof typeof Events];

/**
 * Gets the parameters associated with an event according to the event name.
 */
export type GetEventParamsType<T extends EventsKeys> =
    T extends keyof EventParams ? EventParams[T] : never;

/**
 * Issue an event with argument typing check.
 * @param eventName
 * @param args
 * @returns
 */
export function emitEvent<T extends EventsKeys>(
    eventName: T,
    args?: GetEventParamsType<T>
) {
    return eventEmitter.emit(eventName, args);
}


export type UseEventProps<T extends EventsKeys> = {
    eventName: T;
    callback: (args: GetEventParamsType<T>) => void;
};
